import { z } from "zod";

export const zFileList = z.object({
  view: z.literal("FileList"),
});
export type ZFileList = z.infer<typeof zFileList>;
